import { TenantSubscription } from '../../entities/tenant/tenant';
import { BaseSecurityModule } from '../base.security.module';
import { SecurityModuleName, SecurityRight } from '../security.module';

export enum EquipmentSecurityRight {
    CanAccess = 140_000,
    CanManage = 140_001,
}

export class EquipmentSecurityModule extends BaseSecurityModule<EquipmentSecurityRight> {

    constructor() {
        super(
            SecurityModuleName.Equipment,
            [
                { _id: EquipmentSecurityRight.CanAccess, name: 'Access', basic: true },
                { _id: EquipmentSecurityRight.CanManage, name: 'Manage', basic: true },
            ] as SecurityRight<EquipmentSecurityRight>[]
        );

        this.plan = TenantSubscription.Custom;
    }


}